// src/components/util/formatData.js
// Normalises a raw API value for display in monitoring tables.
//   null / undefined  → "-"
//   ""                → "-"
//   ">>>0<<<"         → "0"   (API sentinel for zero)
//   everything else   → string as-is

export function formatData(value) {
  if (value == null) return "-";
  const str = String(value).trim();
  if (str === "") return "-";
  if (str === ">>>0<<<") return "0";
  return str;
}
